import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  FormControl,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  TextField,
  Menu,
  Tooltip,
  InputBase,
  TableContainer,
  Tabs,
  Tab,
  InputAdornment,
  Typography,
  Container,
  Grid,
  useTheme,
} from "@material-ui/core";
import GetAppIcon from '@material-ui/icons/GetApp';
import { Link, useHistory } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import { useDispatch, useSelector } from "react-redux";
import { changeShiftStatus, getBooking } from "../../store/action";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import apiConfigs from "../../config/config";
import axios from "axios";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import {
  getStaffDetail,
  getCandidateList,
  getCandidateMatchingList,
} from "../../store/action/staff/staffAction";
import {
  getBookingTrust,
  getHospitalList,
  getWardByHospital,
  createFilter,
  deleteFilter,
  getFilterData,
} from "../../store/action/booking/bookingAction";
import { getSpecShiftCreate } from "../../store/action/specialities/specialitiesAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { notificationSuccess } from "../../store/action/notificationMsg";
import { customEnLocale } from "../../helper/customLocale";
import SuperAssign from "./SuperAssign";
import Loading from "../../components/Loading/Loading";
import { GetApp, Visibility } from "@material-ui/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Link as RouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import TablePaginationControls from "../../components/TablePaginationControls";
import theme from "../../theme";
import { ThemeContext } from "../../App";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    padding: 20,
    marginBottom: 0,
    background: theme.palette.background.main,
    borderRadius: "10px !important"
  },

  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 280px)",
  },

  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      padding: "8px !important",
    },
  },
  headerSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // backgroundColor: theme.palette.grey[300],
    background: "transparent",
    borderRadius: "25px",
    padding: 4
  },
  filterBox: {
    padding: 12,
    // backgroundColor: theme.palette.grey[1000],
  },
  filterSearch: {
    background: theme.palette.grey[1000],
  },
  radioGroup: {
    flexDirection: "row",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing(6),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(1),
    transition: theme.transitions.create("width"),
    width: "100%",
    borderBottom: "1px solid #ccc",
    [theme.breakpoints.up("md")]: {
      width: 200,
    },
  },
  formControl: {
    width: "24%",
  },

  statusButton: {
    backgroundColor: "#f5f5f5",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
  },
  tabsRoot: {
    minHeight: 40,
  },
  tabRoot: {
    textTransform: "capitalize",
    minHeight: 40,
    minWidth: 100,
    fontWeight: 500,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  filterIconButton: {
    background: theme.palette.background.paper,
    borderRadius: "50%",
    width: 48,
    height: 48,
    minWidth: 48,
    padding: 0,
    border: "1px solid #ffffff",
    transition: "all 0.2s ease",
    marginRight: "8px",
    "&:hover": {
      background: "#f1f5f9",
      borderColor: "#cbd5e1",
      transform: "scale(1.05)",
    },
  },
  filterIconContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2px",
    position: "relative",
    left: "0",
    right: "0",
  },

  searchIconModern: {
    color: "#666666",
    cursor: "pointer",
    fontSize: 20,
    transition: "color 0.2s ease",
    "&:hover": {
      color: "#1976d2",
    },
  },
}));

const ViewBooking = ({ match }) => {
  const theme = useTheme();
  const history = useHistory();
  const classes = useStyle();
  const dispatch = useDispatch();
  const tabList = [
    "CREATED",
    "CONFIRMED",
    "CANCEL",
    "PROVISIONAL",
    "COMPLETED",
  ];
  const displayTabList = [
    "Vacancy",
    "Booked",
    "Cancel",
    "Provisional",
    "Completed",
  ];
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [open, setOpen] = useState(false);
  const [bookingMultiIds, setBookingMultiIds] = useState("");
  const [flag, setFlag] = useState(true);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const [searchData, setSearchData] = useState({
    search: "",
    specialty: "",
    customer: "",
    site: "",
    ward: "",
    consultants: "",
    candidate: "",
    start_date: moment().subtract(7, "days"),
    end_date: moment(),
    provisional_status: "",
    module_name: "bookings",
  });
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [bookingNotify, setBookingNotify] = useState(false);
  const [getTrustId, setTrustId] = useState();
  const [getHospitalId, setHospitalId] = useState();
  const [speciality, setSpeciality] = useState([]);
  const [trust, setTrust] = useState([]);
  const [hospitalList, setHospitalList] = useState();
  const [wardList, setWardList] = useState([]);
  const [staff, setStaff] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [multipleCandidate, setMultipleCandidates] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [perPage, setPerPage] = useState(15);

  const navigate = (url) => {
    history.push(url); // or history.replace('/dashboard');
  };

  if (
    localStorage.getItem("pageNo") !== undefined &&
    page != localStorage.getItem("pageNo")
  ) {
    setPage(localStorage.getItem("pageNo"));
  }

  if (
    localStorage.getItem("tabStatus") !== undefined &&
    activeIndex != localStorage.getItem("tabStatus")
  ) {
    setActiveIndex(localStorage.getItem("tabStatus"));
  }

  useEffect(() => {
    if (
      localStorage.getItem("pageNo") !== undefined &&
      page != localStorage.getItem("pageNo")
    ) {
      localStorage.setItem("pageNo", page);
    }
  }, [page]);

  useEffect(() => {
    if (
      localStorage.getItem("tabStatus") == undefined &&
      activeIndex != localStorage.getItem("tabStatus")
    ) {
      localStorage.setItem("tabStatus", activeIndex);
    }
  }, [activeIndex]);

  const { bookingItem, loading, shiftStatusSuccess, getFilterDataSuccess } =
    useSelector((state) => state.booking);

  const [bookingStatus, setBookingStatus] = useState({
    booking_id: "",
    status: "",
  });

  const [pdfData, setPdfData] = useState({
    id: [],
  });
  const [bookingData, setBookingData] = useState({
    id: [],
    refId: [],
  });

  const trustHandleChange = (event) => {
    setTrustId(event.target.value);
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
    gethospital();
  };
  const hospitalHandleChange = (event) => {
    setHospitalId(event.target.value);
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
    getWardType(event.target.value);
  };

  const getSpecialities = async () => {
    dispatch(
      getSpecShiftCreate((result) => {
        if (result?.status === true) {
          setSpeciality(result);
        }
      })
    );
  };

  const getTrust = async () => {
    dispatch(
      getBookingTrust((result) => {
        if (result?.status === true) {
          setTrust(result);
        }
      })
    );
  };
  const gethospital = async () => {
    if (getTrustId) {
      dispatch(
        getHospitalList(getTrustId, (result) => {
          if (result?.status === true) {
            setHospitalList(result);
          }
        })
      );
    }
  };
  const getWardType = async (hospitalId) => {
    if (hospitalId && getTrustId) {
      dispatch(
        getWardByHospital(hospitalId, getTrustId, (result) => {
          if (result?.status === true) {
            setWardList(result);
          }
        })
      );
    }
  };
  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getCandidates = async () => {
    dispatch(
      getCandidateList((result) => {
        if (result?.data) {
          setCandidates(result);
        }
      })
    );
  };

  const getBookingList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    status = "",
    specialty = "",
    customer = "",
    site = "",
    ward = "",
    consultants = "",
    candidate = "",
    start_date = searchData?.start_date
      ? moment(searchData?.start_date).format("DD-MM-yyyy")
      : startDate,
    end_date = searchData?.end_date
      ? moment(searchData?.end_date).format("DD-MM-yyyy")
      : endDate,
    provisional_status = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(
      getBooking({
        pageNo,
        perPage,
        search,
        status,
        specialty,
        customer,
        site,
        ward,
        consultants,
        candidate,
        start_date,
        end_date,
        provisional_status,
        type,
        column_name,
      })
    );
  };

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    let status = tabList[activeIndex];
    setPage(value);
    localStorage.setItem("pageNo", value);
    setPdfData(pdfData);
    setBookingData(pdfData);
    getBookingList(
      value,
      perPage,
      searchData.search,
      status,
      searchData?.specialty,
      searchData?.customer,
      searchData?.site,
      searchData?.ward,
      searchData?.consultants,
      searchData?.candidate,
      searchData?.start_date
        ? moment(searchData?.start_date).format("DD-MM-yyyy")
        : startDate,
      searchData?.end_date
        ? moment(searchData?.end_date).format("DD-MM-yyyy")
        : endDate,
      searchData?.provisional_status
    );
  };

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    let status = tabList[activeIndex];
    if (d1) {
      setPage(1);
      setTimeout(
        getBookingList(
          1,
          perPage,
          d1,
          status,
          searchData?.specialty,
          searchData?.customer,
          searchData?.site,
          searchData?.ward,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date
            ? moment(searchData?.start_date).format("DD-MM-yyyy")
            : startDate,
          searchData?.end_date
            ? moment(searchData?.end_date).format("DD-MM-yyyy")
            : endDate,
          searchData?.provisional_status
        ),
        100
      );
    } else {
      setTimeout(
        getBookingList(
          page,
          perPage,
          "",
          status,
          searchData?.specialty,
          searchData?.customer,
          searchData?.site,
          searchData?.ward,
          searchData?.consultants,
          searchData?.candidate,
          searchData?.start_date
            ? moment(searchData?.start_date).format("DD-MM-yyyy")
            : startDate,
          searchData?.end_date
            ? moment(searchData?.end_date).format("DD-MM-yyyy")
            : endDate,
          searchData?.provisional_status,
          order,
          orderBy
        ),
        100
      );
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };
  const handleClickSearch = (event, value) => {
    let status = tabList[activeIndex];
    setPage(1);
    handleMenuClose(true);
    getBookingList(
      1,
      perPage,
      searchData.search,
      status,
      searchData?.specialty,
      searchData?.customer,
      searchData?.site,
      searchData?.ward,
      searchData?.consultants,
      searchData?.candidate,
      searchData?.start_date
        ? moment(searchData?.start_date)
        : moment(startDate),
      searchData?.end_date ? moment(searchData?.end_date) : moment(endDate),
      searchData?.provisional_status,
      order,
      orderBy
    );
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSave = async () => {
    dispatch(createFilter(searchData, "Bookings"));
    getFilterDataByModule();
    let status = tabList[activeIndex];
    setPage(1);
    if (getFilterDataSuccess?.data?.start_date) {
      setSearchData({
        ...searchData,
        start_date: getFilterDataSuccess?.data?.start_date,
      });
      setStartDate(getFilterDataSuccess?.data?.start_date);
    }
    if (getFilterDataSuccess?.data?.end_date) {
      setSearchData({
        ...searchData,
        end_date: getFilterDataSuccess?.data?.end_date,
      });
      setEndDate(getFilterDataSuccess?.data?.end_date);
    }

    let iStartDate = searchData?.start_date
      ? searchData?.start_date
      : getFilterDataSuccess
        ? getFilterDataSuccess?.data?.start_date
        : moment().subtract(7, "days").format("DD-MM-yyyy");
    let iEndDate = searchData?.end_date
      ? searchData?.end_date
      : getFilterDataSuccess?.data?.end_date
        ? getFilterDataSuccess?.data?.end_date
        : moment();

    setStartDate(iStartDate);
    setEndDate(iEndDate);
    setTimeout(
      getBookingList(
        1,
        perPage,
        searchData?.search
          ? searchData?.search
          : getFilterDataSuccess?.data?.search,
        status,
        searchData?.specialty
          ? searchData?.specialty
          : getFilterDataSuccess?.data?.specialty,
        searchData?.customer
          ? searchData?.customer
          : getFilterDataSuccess?.data?.customer,
        searchData?.site ? searchData?.site : getFilterDataSuccess?.data?.site,
        searchData?.ward ? searchData?.ward : getFilterDataSuccess?.data?.ward,
        searchData?.consultants
          ? searchData?.consultants
          : getFilterDataSuccess?.data?.consultants,
        searchData?.candidate
          ? searchData?.candidate
          : getFilterDataSuccess?.data?.candidate,

        iStartDate,

        iEndDate,

        searchData?.provisional_status
          ? searchData?.provisional_status
          : getFilterDataSuccess?.data?.provisional_status,
        order,
        orderBy
      ),
      1000
    );
    handleMenuClose(true);
  };
  const handleReset = () => {
    let status = tabList[activeIndex];
    let data = {
      search: "",
      specialty: "",
      candidate: "",
      customer: "",
      site: "",
      ward: "",
      consultants: "",
      start_date: moment().subtract(7, "days"),
      end_date: moment(),
      provisional_status: "",
      module_name: "bookings",
    };
    setSearchData(data);
    handleMenuClose(true);
    setTimeout(getBookingList(page, "", status), 100);
    dispatch(deleteFilter(data, "bookings")).then(() => {
      setFlag(!flag);
      const today = new Date();
      const defaultStartDate = new Date(
        today.getTime() - 7 * 24 * 60 * 60 * 1000
      ); // Today - 15 days

      getBookingList({
        search: "",
        specialty: "",
        candidate: "",
        customer: "",
        site: "",
        ward: "",
        consultants: "",
        start_date: moment(defaultStartDate).format("DD-MM-yyyy"),
        end_date: moment(today).format("DD-MM-yyyy"),
        provisional_status: "",
        module_name: "bookings",
      });
    });
  };

  const resetBooking = () => {
    setBookingData({ id: [], refId: [] });
  };

  useEffect(() => {
    getSpecialities();
    getTrust();
    gethospital();
    getWardType(getHospitalId);
    getStaff();
    getCandidates();
    getFilterDataByModule();
  }, []);

  useEffect(() => {
    if (startDate) {
      setSearchData({
        ...searchData,
        start_date: startDate,
      });
    }
  }, [startDate]);

  useEffect(() => {
    if (endDate) {
      setSearchData({
        ...searchData,
        end_date: endDate,
      });
    }
  }, [endDate]);

  useEffect(() => {
    if (getTrustId) {
      gethospital();
    }
  }, [getTrustId]);

  useEffect(() => {
    if (getHospitalId) {
      getWardType(getHospitalId);
    }
  }, [getHospitalId]);

  const tabChange = (index, list) => {
    pdfData.id = [];
    setPage(1);
    localStorage.setItem("pageNo", 1);
    setSearchData({ ...searchData });
    setActiveIndex(index);
    setPdfData({
      id: [],
    });
    setBookingData({
      id: [],
      refId: [],
    });
    localStorage.setItem("tabStatus", index);
    setTimeout(
      getBookingList(
        1,
        perPage,
        searchData?.search,
        list,
        searchData?.specialty,
        searchData?.customer,
        searchData?.site,
        searchData?.ward,
        searchData?.consultants,
        searchData?.candidate,
        searchData?.start_date
          ? moment(searchData?.start_date).format("DD-MM-yyyy")
          : startDate,
        searchData?.end_date
          ? moment(searchData?.end_date).format("DD-MM-yyyy")
          : endDate,
        searchData?.provisional_status,
        order,
        orderBy
      ),
      100
    );
  };

  const downloadPdf = async (booking_id, reference_id) => {
    setLoadings(true);
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-invoice/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", reference_id + ".pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const deleteBooking = async () => {
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .post(
        `${apiConfigs.API_URL}api/organization/booking/delete`,
        bookingData,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          dispatch(notificationSuccess(response?.data?.message));
          setBookingData({ id: [], refId: [] }); //this is added for hiding button in topBar Doen by preet paunikar
          setTimeout(() => {
            getBookingList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const dublicateBooking = async (paymentSchemeId) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/dublicate-booking/${paymentSchemeId}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status == true) {
          dispatch(notificationSuccess(response?.data?.message));
          setTimeout(() => {
            getBookingList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.error("error.message", error.message);
      });
  };
  const multipleInvoiceDownload = async () => {
    setLoadings(true);
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(`${apiConfigs.API_URL}api/organization/multiple-invoice`, pdfData, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Invoice.pdf");
        document.body.appendChild(link);
        link.click();
        setLoadings(false);
      })
      .catch((error) => {
        // setTimesheetError("Sorry timesheet upload failed");
      });
  };
  const handleCheckboxClick = (event, ids) => {
    console.log(event.target.checked, "event.target.checked");
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked) {
      multiplePdf.id.push(parseFloat(ids));
      setPdfData(multiplePdf);
    } else {
      const newData = multiplePdf.id.filter((item) => item != parseFloat(ids));
      multiplePdf.id = newData;
      setPdfData(multiplePdf);
    }
  };
  const handleBookingCheckboxClick = (event, ids, refIds) => {
    const multiplePdf = JSON.parse(JSON.stringify(bookingData));
    const isChecked = event.target.checked;
    if (isChecked) {
      multiplePdf.id.push(parseFloat(ids));
      multiplePdf.refId.push(parseFloat(refIds));
      setBookingData(multiplePdf);
    } else {
      const newData = multiplePdf.id.filter((item) => item != parseFloat(ids));
      const newDataRef = multiplePdf.refId.filter(
        (item) => item != parseFloat(refIds)
      );
      multiplePdf.id = newData;
      multiplePdf.refId = newDataRef;
      setBookingData(multiplePdf);
    }
  };
  const handleCheckboxAllClick = (event) => {
    const multiplePdf = JSON.parse(JSON.stringify(pdfData));
    const isChecked = event.target.checked;
    if (isChecked && bookingItem?.data?.data?.length > 0) {
      const createArray = [];
      bookingItem?.data?.data.map((row, index) => {
        createArray.push(row.id);
      });
      multiplePdf.id = createArray;
      setPdfData(multiplePdf);
    } else {
      multiplePdf.id = [];
      setPdfData(multiplePdf);
    }
  };
  useEffect(() => {
    if (bookingStatus.booking_id !== "") {
      dispatch(changeShiftStatus(bookingStatus));
      setBookingNotify(true);
      setTimeout(() => {
        getBookingList();
      }, 4000);
    }
  }, [bookingStatus]);

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleMenu = (event) => {
    const today = new Date();
    const defaultStartDate = new Date(
      today.getTime() - 7 * 24 * 60 * 60 * 1000
    ); // Today - 15 days

    if (
      searchData.search === "" &&
      searchData.specialty === "" &&
      searchData.customer === "" &&
      searchData.site === "" &&
      searchData.ward === "" &&
      searchData.consultants === "" &&
      searchData.candidate === "" &&
      searchData.start_date === "" &&
      searchData.end_date === "" &&
      searchData.provisional_status === ""
    ) {
      getFilterDataByModule();
    }
    setAnchorEl(event.currentTarget);
    if (getFilterDataSuccess?.data?.start_date != undefined) {
      setStartDate(getFilterDataSuccess?.data?.start_date);
    } else {
      setStartDate(moment(defaultStartDate).format("YYYY-MM-DD"));
    }
    if (
      getFilterDataSuccess?.data?.start_date != undefined &&
      getFilterDataSuccess?.data?.start_date != "Invalid date"
    ) {
      setEndDate(getFilterDataSuccess?.data?.end_date);
    } else {
      setEndDate(today);
    }
    gethospital();
    getWardType(getHospitalId);
  };

  const getFilterDataByModule = () => {
    let data = {
      search: "",
      specialty: "",
      candidate: "",
      customer: "",
      site: "",
      ward: "",
      consultants: "",
      start_date: "",
      end_date: "",
      provisional_status: "",
      module_name: "bookings",
    };

    dispatch(getFilterData("bookings"));
    if (getFilterDataSuccess?.data) {
      if (getFilterDataSuccess?.data?.specialty !== "") {
        data.specialty = getFilterDataSuccess?.data?.specialty;
      }
      if (getFilterDataSuccess?.data?.customer !== "") {
        data.customer = getFilterDataSuccess?.data?.customer;
        setTrustId(getFilterDataSuccess?.data?.customer);
      }
      if (getFilterDataSuccess?.data?.site !== "") {
        data.site = getFilterDataSuccess?.data?.site;
        gethospital();
        setHospitalId(getFilterDataSuccess?.data?.site);
      }
      if (getFilterDataSuccess?.data?.ward !== "") {
        getWardType(getHospitalId);
        data.ward = getFilterDataSuccess?.data?.ward;
      }
      if (getFilterDataSuccess?.data?.consultants !== "") {
        data.consultants = getFilterDataSuccess?.data?.consultants;
      }
      if (getFilterDataSuccess?.data?.candidate !== "") {
        data.candidate = getFilterDataSuccess?.data?.candidate;
      }
      if (getFilterDataSuccess?.data?.provisional_status) {
        data.provisional_status =
          getFilterDataSuccess?.data?.provisional_status;
      }
      if (getFilterDataSuccess?.data?.start_date) {
        data.start_date = getFilterDataSuccess?.data?.start_date;
        setStartDate(getFilterDataSuccess?.data?.start_date);
      }
      if (getFilterDataSuccess?.data?.end_date) {
        data.end_date = getFilterDataSuccess?.data?.end_date;
        setEndDate(getFilterDataSuccess?.data?.end_date);
      }
      setSearchData(data);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy == property && order == "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSuperAssign = async (bookingIds) => {
    if (bookingIds?.length > 0) {
      setBookingMultiIds(bookingIds);
      setOpen(true);
      const payload = { booking_ids: bookingIds };
      const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
      await axios
        .post(
          `${apiConfigs.API_URL}api/organization/get-search-multiple-booking`,
          payload,
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${loggedInUser}`,
            },
          }
        )
        .then((response) => {
          if (response?.data) {
            setMultipleCandidates(response?.data?.data);
          }
        })
        .catch((error) => {
          console.error("error.message", error.message);
        });
    }
  };
  const handleClose = (action) => {
    setOpen(false);
  };

  useEffect(() => {
    let sStartDate = getFilterDataSuccess?.data?.start_date
      ? getFilterDataSuccess?.data?.start_date
      : moment().subtract(7, "days");
    setStartDate(sStartDate);
    let sEndDate = getFilterDataSuccess?.data?.end_date
      ? getFilterDataSuccess?.data?.end_date
      : moment();

    setEndDate(sEndDate);
    let status = tabList[activeIndex];
    setTimeout(
      getBookingList(
        page,
        perPage,
        searchData?.search
          ? searchData?.search
          : getFilterDataSuccess?.data?.search,
        status,
        searchData?.specialty
          ? searchData?.specialty
          : getFilterDataSuccess?.data?.specialty,
        searchData?.customer
          ? searchData?.customer
          : getFilterDataSuccess?.data?.customer,
        searchData?.site ? searchData?.site : getFilterDataSuccess?.data?.site,
        searchData?.ward ? searchData?.ward : getFilterDataSuccess?.data?.ward,
        searchData?.consultants
          ? searchData?.consultants
          : getFilterDataSuccess?.data?.consultants,
        searchData?.candidate
          ? searchData?.candidate
          : getFilterDataSuccess?.data?.candidate,
        searchData?.start_date
          ? moment(searchData?.start_date).format("DD-MM-yyyy")
          : startDate,
        searchData?.end_date
          ? moment(searchData?.end_date).format("DD-MM-yyyy")
          : endDate,
        searchData?.provisional_status
          ? searchData?.provisional_status
          : getFilterDataSuccess?.data?.provisional_status,
        order,
        orderBy
      ),
      1000
    );
  }, [orderBy, order, flag, page, perPage]);

  let loggedInRole = localStorage.getItem("role");
  loggedInRole = loggedInRole && loggedInRole.replace(/['"]+/g, "");

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1);
    let status = tabList[activeIndex];
    getBookingList(
      page,
      perPage,
      searchData?.search
        ? searchData?.search
        : getFilterDataSuccess?.data?.search,
      status,
      searchData?.specialty
        ? searchData?.specialty
        : getFilterDataSuccess?.data?.specialty,
      searchData?.customer
        ? searchData?.customer
        : getFilterDataSuccess?.data?.customer,
      searchData?.site ? searchData?.site : getFilterDataSuccess?.data?.site,
      searchData?.ward ? searchData?.ward : getFilterDataSuccess?.data?.ward,
      searchData?.consultants
        ? searchData?.consultants
        : getFilterDataSuccess?.data?.consultants,
      searchData?.candidate
        ? searchData?.candidate
        : getFilterDataSuccess?.data?.candidate,
      searchData?.start_date
        ? moment(searchData?.start_date).format("DD-MM-yyyy")
        : startDate,
      searchData?.end_date
        ? moment(searchData?.end_date).format("DD-MM-yyyy")
        : endDate,
      searchData?.provisional_status
        ? searchData?.provisional_status
        : getFilterDataSuccess?.data?.provisional_status,
      order,
      orderBy
    );
  };
  function formatTime12Hour(time24) {
    const [hours, minutes, seconds] = time24.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    date.setSeconds(parseInt(seconds, 10));

    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
  }
  const { mode } = useContext(ThemeContext);
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  return (
    <>

      {loading && <Loading open={loading} />}

      {loadings && <Loading open={loadings} />}

      {bookingNotify && shiftStatusSuccess?.message && (
        <Notification data={shiftStatusSuccess?.message} status="success" />
      )}
      <Box mb={1} className={classes.headerSection} >
        {/* Tabs - will take up remaining space */}
        {/* <Tabs
          value={Math.abs(activeIndex)}
          onChange={(e, index) => tabChange(index, tabList[index])}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          style={{ margin: 0, background: "transparent" }}
        >
          {tabList.map((list, index) => (
            <Tab
              key={index + 888}
              label={displayTabList[index].toLowerCase()}
              style={{ textTransform: "capitalize" }}
            />
          ))}
        </Tabs> */}
        <Tabs
          value={Math.abs(activeIndex)}
          onChange={(e, index) => tabChange(index, tabList[index])}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          style={{ margin: 0, background: theme.palette.background.drawer }}
        >
          {tabList.map((list, index) => (
            <Tab
              key={index + 888}
              label={displayTabList[index]}
              sx={{
                textTransform: "capitalize",
                fontSize: "0.95rem",
                fontWeight: activeIndex === index ? 600 : 400,
                color: activeIndex === index ? "primary.main" : "listItem",
                minHeight: 48,
                px: 3,
                "&:hover": {
                  color: "primary.main",
                  // backgroundColor: "action.hover",
                  borderRadius: 1,
                },
              }}
            />
          ))}
        </Tabs>
        <Box display="flex" alignItems="center" ml={0} >
          {/* Search box */}
          <Box display="flex" alignItems="center" mr={1}>

            <TextField
              className="modernSearchField"
              size="small"
              placeholder="Search now..."
              name="search"
              variant="outlined"
              onChange={handleSearchChange}
              onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      style={{
                        color: "#856f6f",
                        cursor: "pointer",
                      }}
                      onClick={handleClickSearch}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Tooltip title="Filters">
            <Button
              onClick={handleMenu}
              className={classes.filterIconButton}
              style={{ mr: 2 }}
            >
              <FilterListIcon />
            </Button>
          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            open={openMenu}
            onClose={handleMenuClose}
            className="filterBookingSearch"
          >
            <div className={`${classes.filterBox}`}>
              <Box className={classes.radioGroup}>
                <Box mt={3} mb={3} display="flex" alignItems="center">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    flexGrow={1}
                  >
                    <FormControl className={classes.formControl} variant="outlined">
                      <Autocomplete
                        id="specialty-select"
                        options={speciality?.data || []}
                        getOptionLabel={(option) => option?.speciality_name || ""}
                        value={
                          speciality?.data?.find((s) => s.id === searchData?.specialty) || null
                        }
                        onChange={(event, newValue) => {
                          setSearchData({
                            ...searchData,
                            specialty: newValue ? newValue.id : "",
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Specialty"
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>
                    {/* <FormControl
                      className={classes.formControl}
                      variant="outlined"
                    >
                      <InputLabel>Customer</InputLabel>
                      <Select
                        label="Customer"
                        name="customer"
                        onChange={trustHandleChange}
                        value={
                          searchData?.customer
                            ? searchData?.customer
                            : getTrustId
                        }
                      >
                        <MenuItem value="">Select Customer</MenuItem>
                        {trust?.data !== undefined &&
                          trust?.data &&
                          trust?.data.map((trustList, index) => {
                            return (
                              <MenuItem
                                value={trustList.id}
                                key={index + 11111}
                              >
                                {trustList.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl> */}
                    <FormControl className={classes.formControl} variant="outlined">
                      <Autocomplete
                        id="customer-select"
                        options={trust?.data || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={
                          trust?.data?.find(
                            (c) => c.id === (searchData?.customer || getTrustId)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          trustHandleChange({
                            target: {
                              name: "customer",
                              value: newValue ? newValue.id : "",
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Customer"
                            variant="outlined"
                            placeholder="Select Customer"
                          />
                        )}
                      />
                    </FormControl>
                    {/* <FormControl
                      className={classes.formControl}
                      variant="outlined"
                    >
                      <InputLabel>Site</InputLabel>
                      <Select
                        label="Site"
                        name="site"
                        onChange={hospitalHandleChange}
                        value={
                          searchData?.site ? searchData?.site : getHospitalId
                        }
                      >
                        <MenuItem value="">Select Site</MenuItem>
                        {hospitalList?.data !== undefined &&
                          hospitalList?.data &&
                          hospitalList?.data.map((List, index) => {
                            return (
                              <MenuItem value={List.id} key={index + 1}>
                                {List.hospital_name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl> */}
                    <FormControl className={classes.formControl} variant="outlined">
                      <Autocomplete
                        id="site-select"
                        options={hospitalList?.data || []}
                        getOptionLabel={(option) => option?.hospital_name || ""}
                        value={
                          hospitalList?.data?.find(
                            (h) => h.id === (searchData?.site || getHospitalId)
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          hospitalHandleChange({
                            target: {
                              name: "site",
                              value: newValue ? newValue.id : "",
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Site"
                            variant="outlined"
                            placeholder="Select Site"
                          />
                        )}
                      />
                    </FormControl>
                    {/* <FormControl
                      className={classes.formControl}
                      variant="outlined"
                    >
                      <InputLabel>Ward</InputLabel>
                      <Select
                        label="Ward"
                        name="ward"
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        value={searchData?.ward}
                      >
                        <MenuItem value="">Select Ward</MenuItem>
                        {wardList?.data !== undefined &&
                          wardList?.data &&
                          wardList?.data.map((list, index) => {
                            return (
                              <MenuItem value={list.id} key={index + 11}>
                                {list.ward_name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl> */}
                    <FormControl className={classes.formControl} variant="outlined">
                      <Autocomplete
                        id="ward-select"
                        options={wardList?.data || []}
                        getOptionLabel={(option) => option?.ward_name || ""}
                        value={
                          wardList?.data?.find((w) => w.id === searchData?.ward) || null
                        }
                        onChange={(event, newValue) => {
                          setSearchData({
                            ...searchData,
                            ward: newValue ? newValue.id : "",
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Ward"
                            variant="outlined"
                            placeholder="Select Ward"
                          />
                        )}
                      />
                    </FormControl>
                  </Box>
                </Box>

                <Box mt={2} mb={1} display="flex" alignItems="center">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    flexGrow={1}
                  >
                    {/* <FormControl
                      className={classes.formControl}
                      variant="outlined"
                    >
                      <InputLabel>Consultants</InputLabel>
                      <Select
                        label="Consultants"
                        name="consultants"
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        value={searchData?.consultants}
                      >
                        <MenuItem value="">Select Consultants</MenuItem>
                        {staff?.data !== undefined &&
                          staff?.data &&
                          staff?.data.map((trustList, index) => {
                            return (
                              <MenuItem value={trustList.id} key={index + 111}>
                                {trustList.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl> */}
                    <FormControl className={classes.formControl} variant="outlined">
                      <Autocomplete
                        id="consultants-select"
                        options={staff?.data || []}
                        getOptionLabel={(option) => option?.name || ""}
                        value={
                          staff?.data?.find((c) => c.id === searchData?.consultants) || null
                        }
                        onChange={(event, newValue) => {
                          setSearchData({
                            ...searchData,
                            consultants: newValue ? newValue.id : "",
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Consultants"
                            variant="outlined"
                            placeholder="Select Consultants"
                          />
                        )}
                      />
                    </FormControl>
                    <Box className={classes.formControl}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={customEnLocale}
                        localeText={{ start: "Check-in", end: "Check-out" }}
                      >
                        <DatePicker
                          label="Start Date"
                          // inputFormat="dd/MM/yyyy"
                          name="start_date"
                          onChange={(newValue) => setStartDate(newValue)}
                          value={
                            startDate !== undefined
                              ? startDate
                              : moment().subtract(7, "d").format("YYYY-MM-DD")
                          }
                          firstDayOfWeek={1}
                          inputFormat="dd-MMM-yyyy"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{ width: "100%" }}
                              variant="outlined"
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box className={classes.formControl}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={customEnLocale}
                        localeText={{ start: "Check-in", end: "Check-out" }}
                      >
                        <DatePicker
                          label="End Date"
                          // inputFormat="dd/MM/yyyy"
                          name="end_date"
                          onChange={(newValue) => setEndDate(newValue)}
                          value={
                            endDate !== undefined
                              ? endDate
                              : moment().format("YYYY-MM-DD")
                          }
                          firstDayOfWeek={1}
                          inputFormat="dd-MMM-yyyy"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              style={{ width: "100%" }}
                              variant="outlined"
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </Box>
                    <FormControl
                      className={classes.formControl}
                      variant="outlined"
                    >
                      <InputLabel>Provisional Status</InputLabel>
                      <Select
                        label="provisional_status"
                        name="provisional_status"
                        onChange={(e) =>
                          setSearchData({
                            ...searchData,
                            [e.target.name]: e.target.value,
                          })
                        }
                        value={searchData?.provisional_status}
                      >
                        <MenuItem value="">Select Status</MenuItem>
                        <MenuItem value="CONFIRMED" key={1111}>
                          CONFIRMED
                        </MenuItem>
                        <MenuItem value="CREDIT NOTES" key={11111}>
                          CREDIT NOTES
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box mt={2} mb={1} display="flex" alignItems="center">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    flexGrow={1}
                  >
                    <Grid container spacing={2}>
                      <Grid item sm={6} md={6}>
                        <Autocomplete
                          fullWidth
                          id="candidate-select"
                          options={candidates?.data || []}
                          getOptionLabel={(option) => option?.name || ""}
                          value={
                            candidates?.data?.find((c) => c.id === searchData?.candidate) || null
                          }
                          onChange={(event, newValue) => {
                            setSearchData({
                              ...searchData,
                              candidate: newValue ? newValue.id : "",
                            });
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Candidate"
                              variant="outlined"
                              placeholder="Select Candidate"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item sm={6} md={6}>
                        <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
                          <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: "16px", marginLeft: "16px" }}
                            className={classes.searchIcondet}
                            onClick={handleClickSearch}
                          >
                            Search
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={handleReset}
                          >
                            Reset
                          </Button>

                          <Button
                            variant="contained"
                            color="secondary"
                            style={{ marginRight: "16px", marginLeft: "16px" }}
                            className={classes.searchIcondet}
                            onClick={handleClickSave}
                          >
                            Save
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </div>
          </Menu>

          <Box display="flex" alignItems="center" mr={1}>
            {/* Other action buttons */}
            {bookingData?.id?.length > 0 && (
              ((loginUserInfo?.role === "STAFF" &&
                loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "bookings-delete")) ||
                loginUserInfo?.role !== "STAFF") && (
                <Button variant="contained" color="secondary" onClick={deleteBooking} style={{ marginRight: 8 }}>
                  Delete
                </Button>
              )
            )}

            {bookingData?.id?.length > 0 && (
              <Button variant="contained" color="secondary" onClick={() => handleSuperAssign(bookingData.id)} style={{ marginRight: 8 }}>
                Super Assignment
              </Button>
            )}

            {pdfData?.id?.length > 0 && ((loginUserInfo?.role === "STAFF" &&
              loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-download-invoice")) || (loginUserInfo?.role !== "STAFF")) && (
                <Button variant="contained" color="secondary" onClick={multipleInvoiceDownload} style={{ marginRight: 8 }}>
                  <GetApp /> Download PDF
                </Button>
              )}

            {(staffDetail != "Finance" && (loginUserInfo?.role !== "STAFF" ||
              (loginUserInfo?.role === "STAFF" && loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-create")))) &&
              (
                <Button color="primary" variant="contained" onClick={() => navigate(`${match.url}/create`)}>
                  <AddIcon className="mr-2" /> Add Booking
                </Button>
              )}
          </Box>
        </Box>
      </Box>
      {/* </Box> */}

      <Paper className={`${classes.root} mb-6 mt-5`}>
        {bookingItem?.data ? (
          <>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <EnhancedTableHead
                  handleCheckboxAllClick={handleCheckboxAllClick}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={(event, property) => {
                    handleRequestSort(
                      property,
                      setOrder,
                      setOrderBy,
                      orderBy,
                      order
                    );
                  }}
                  rowCount={bookingItem?.data?.data?.length}
                  headCells={headCells[activeIndex ? activeIndex : 0]}
                  activeIndex={activeIndex}
                  pdfDataCount={pdfData?.id?.length}
                />

                <TableBody>
                  {bookingItem?.data?.data &&
                    bookingItem?.data?.data.map((row, index) => {
                      let userRole =
                        bookingItem?.data?.data[0]["loggedUserDesignation"];
                      userRole = userRole && userRole.replace(/['"]+/g, "");
                      const dateFormate = row.date
                        .toString()
                        .split("-")
                        .reverse()
                        .join("-");
                      const originalDate = row.invoice_date || null;
                      let newdate;
                      if (originalDate) {
                        const parts = originalDate.split(" ");
                        const datePart = parts[0];
                        const timePart = parts[1];
                        const dateParts = datePart.split("-");
                        const day = dateParts[2];
                        const month = dateParts[1];
                        const year = dateParts[0];
                        newdate = `${day}-${month}-${year} ${timePart}`;
                      }

                      return (
                        <TableRow key={index + 666}>
                          {activeIndex == 4 && (
                            <TableCell scope="row">
                              <Checkbox
                                value={row.id}
                                checked={pdfData?.id?.includes(row.id)}
                                onClick={(event) =>
                                  handleCheckboxClick(event, row.id)
                                }
                                style={{ color: theme.palette.listItem }}
                                className="select"
                              />
                            </TableCell>
                          )}
                          {activeIndex == 0 && (
                            <TableCell scope="row">
                              <Checkbox
                                value={row.id}
                                checked={pdfData?.id?.includes(row.id)}
                                onClick={(event) =>
                                  handleCheckboxClick(
                                    event,
                                    row.id,
                                    row.reference_id
                                  )
                                }
                                style={{ color: theme.palette.listItem }}
                                className="select"
                              />
                            </TableCell>
                          )}
                          <TableCell scope="row">
                            <MuiLink
                              component={
                                (loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "bookings-view")) ||
                                  loginUserInfo?.role !== "STAFF" ? RouterLink : "span"
                              }
                              to="#"
                              onClick={(e) => {
                                if ((loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "bookings-view")) ||
                                  loginUserInfo?.role !== "STAFF") {
                                  e.preventDefault();
                                  onhandlClick(row.id)
                                } else {
                                  e.preventDefault();
                                }
                              }}
                              underline="hover"
                              sx={{
                                cursor: (loginUserInfo?.role === "STAFF" &&
                                  loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "bookings-view")) || (loginUserInfo?.role !== "STAFF") ? "pointer" : "not-allowed",
                                color: "#3e81c3"
                              }}
                              className="clickableLink"
                            >
                              {row?.id}
                            </MuiLink>
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            {row.name}
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.hospital_name}</TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.ward_name}</TableCell>
                          {activeIndex > 0 && (
                            <TableCell align="left" style={{ color: theme.palette.listItem }}>
                              {row.candidate_name}
                            </TableCell>
                          )}
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.grade_name}</TableCell>
                          <TableCell
                            align="left"
                            style={{ whiteSpace: "nowrap", color: theme.palette.listItem }}
                          >
                            {dateFormate &&
                              moment(dateFormate, "DD-MM-YYYY", true).isValid()
                              ? moment(dateFormate, "DD-MM-YYYY").format("DD-MMM-YYYY")
                              : "-"}                          </TableCell>
                          {activeIndex == 4 && (
                            <TableCell align="right" style={{ color: theme.palette.listItem }}>{newdate && moment(newdate).isValid() ? moment(newdate).format("DD-MMM-YYYY").toUpperCase() : "-"}</TableCell>
                          )}
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>
                            {formatTime12Hour(row.start_time)} <br /> {formatTime12Hour(row.end_time)}
                          </TableCell>
                          <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.createdByName} </TableCell>

                          <TableCell align="center">
                            <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                              {activeIndex === 4 && (
                                <>
                                  <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
                                    {loggedInRole === "ORGANIZATION" || userRole === "Admin" || userRole === "Finance" ? (
                                      <Box
                                        onClick={() => downloadPdf(row.id, row.invoice_number)}
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <GetAppIcon style={{ color: theme.palette.listItem }} />
                                      </Box>
                                    ) : (
                                      loginUserInfo?.role === "STAFF" &&
                                      loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "bookings-view") && (
                                        <Box
                                          size="small"
                                          variant="contained"
                                          color="primary"
                                          style={{ cursor: "pointer" }}
                                          disabled
                                          onClick={() => downloadPdf(row.id, row.invoice_number)}
                                        >
                                          <GetAppIcon style={{ color: theme.palette.listItem }} />
                                        </Box>
                                      )
                                    )}
                                  </Box>
                                </>
                              )}
                              {activeIndex == 0 && ((loginUserInfo?.role === "STAFF" &&
                                loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-create")) || (loginUserInfo?.role !== "STAFF")) && (
                                  <Link
                                    to="#"
                                    onClick={() => dublicateBooking(row.id)}
                                  >
                                    <FileCopyOutlinedIcon />
                                  </Link>
                                )}
                              {/* {((loginUserInfo?.role === "STAFF" &&
                              loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-view")) || (loginUserInfo?.role !== "STAFF")) && (
                                <Box
                                  style={{ marginRight: "10px", marginLeft: "10px", cursor: "pointer" }}
                                  onClick={() => onhandlClick(row.id)}
                                  variant="outlined"
                                  size="small"
                                >
                                  <Visibility variant="outlined" size="small" />
                                </Box>
                              )} */}
                            </Box>
                          </TableCell>

                          {/* {activeIndex == 0 && ((loginUserInfo?.role === "STAFF" &&
                          loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-create")) || (loginUserInfo?.role !== "STAFF")) && (
                            <TableCell className="mr-0">
                              <Link
                                to="#"
                                onClick={() => dublicateBooking(row.id)}
                              >
                                <FileCopyOutlinedIcon />
                              </Link>
                            </TableCell>
                          )} */}

                          {/* <TableCell className="ml-0" align="center">
                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-view")) || (loginUserInfo?.role !== "STAFF")) && (
                              <Button
                                onClick={() => onhandlClick(row.id)}
                                variant="outlined"
                                size="small"
                              >
                                View
                              </Button>
                            )}
                        </TableCell> */}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePaginationControls
              page={page}
              rowsPerPage={perPage}
              totalRecords={bookingItem?.data?.total}
              onPageChange={handleChangePage}
              handlePerPageChange={handlePerPageChange}
            />
          </>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="300px"
            borderRadius="12px"
            bgcolor={theme.palette.background.paper}
            textAlign="center"
          >
            <Typography variant="h6" color="textSecondary">
              Sorry, booking not available!
            </Typography>
          </Box>
        )}
        {/* <Box className="mt-5" display="flex" justifyContent="flex-end">
          <Pagination
            onChange={handleChangePage}
            page={
              page <= bookingItem?.data?.last_pag
                ? page
                : parseInt(localStorage.getItem("pageNo"))
            }
            count={bookingItem?.data?.last_page}
            showFirstButton
            showLastButton
          />
        </Box> */}
      </Paper>
      <SuperAssign
        open={open}
        handleClose={handleClose}
        resetBooking={resetBooking}
        bookingMultiIds={bookingMultiIds}
        bookingMultiRefs={bookingData.refId}
        getBookingList={() => getBookingList()}
        multipleCandidate={multipleCandidate}
      />
    </>
  );
};

export default ViewBooking;
